import inputConfig, { AlmeInputConfig } from "../AlmeInput/AlmeInputConfig";
import React, { ReactElement } from "react";

import ChatIcon from '@material-ui/icons/Chat';
import { ButtonProps } from "@material-ui/core";
import { AlmeColorProp } from "../../models/AlmeColorMapping";

interface LaunchPointConfig extends AlmeInputConfig {
    /**
     * Optional - remove for text launch button
     */
    launchIcon?: ReactElement;
    /**
     * Optional - remove for launch icon button
     */
    buttonText?: string;
    /**
     * Optional - Include input filed text to allow for global launch with a question
     */
    inputFieldText?: string;
    titleText?: string;
    launchButton: {
        variant: ButtonProps['variant'];
        color: AlmeColorProp;
    };
}

export interface AlmeLaunchPointConfig {
    /**
     * Remove/Set all to undefined to disable global launch point.
     */
    launchPoint: LaunchPointConfig;
}

/**
 * This is the baseline launch point config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig: AlmeLaunchPointConfig = {
    launchPoint: {
        launchIcon: <ChatIcon />,
        launchButton: {
            color: 'primary',
            variant: 'contained',
        },
        ...inputConfig,
    },
};

export default defaultConfig;